<template>
    <el-drawer
        title="审核"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content"> 
            <el-form
                :model="formData"
                ref="formData"
                label-position="top"
                
            >
				<template v-if="status != 2 && status != 3">
					<div v-if="cancelData">
					   <p class="color-danger">退票之前请确认核对：</p>
					   <p class="MT10">演出ID：{{cancelData.activityId}} <span v-if="cancelData && cancelData.orderStatus == 4 && data && data.ticketTypeStr == '实体票'" class="color-danger">（实体票，已发货）</span></p>
					   <p class="MT10">演出名称：{{cancelData.activityName}} </p>
					   <p class="MT10 color-danger">需退票数:{{cancelData.cancelNum}},包含以下票品</p>
					   <div class="temp-table"  v-if="cancelData && cancelData.ticketList && cancelData.ticketList.length > 0 ">
						   <el-table
							   :data="cancelData.ticketList"
							   style="width: 100%"
							   size="small"
							   border
						   >
							   <el-table-column prop="ticketName" label="票品&场次名称" min-width="100"></el-table-column>
							   <el-table-column prop="userName" label="观演人" min-width="80"></el-table-column>
							   <el-table-column prop="orderTime" label="下单时间" min-width="80"></el-table-column>	
							   <el-table-column prop="num" label="数量" min-width="100"></el-table-column>				           
						   </el-table>
					   </div>
					</div>				
					 <template v-if="cancelData && cancelData.cancelRecord && cancelData.cancelRecord.length > 0">
					   <p class="MT20">当前演出用户取消记录:</p>
					   <div class="temp-table">
						   <el-table
							   :data="cancelData.cancelRecord"
							   style="width: 100%"
							   size="small"
							   border
						   >
							   <el-table-column prop="ticketName" label="票品&场次名称" min-width="100"></el-table-column>
							   <el-table-column prop="userName" label="观演人" min-width="80"></el-table-column>
							   <el-table-column prop="orderTime" label="下单时间" min-width="80"></el-table-column>
							   <el-table-column prop="num" label="已取消订单数" min-width="100"></el-table-column>	
						   </el-table>
						   <el-link class="link color-blue"  :href="`/activityManage/order/list?searchType=1&searchValue=${cancelData.activityId}&searchType2=5&searchValue2=${cancelData.userId}&orderStatus=7`" target="_blank">点击查看已取消订单</el-link>
					   </div>				 					   
					 </template>
					<!-- 关联的权益票订单（审核通过取消主票会同步取消权益票订单） -->
					<template v-if="cancelData && cancelData.benefitOrderList && cancelData.benefitOrderList.length > 0">
					   <p class="MT10 color-danger">该订单有关联的权益票订单,审核通过后会同步取消以下权益票订单:</p>
					   <div class="temp-table">
						   <el-table
							   :data="cancelData.benefitOrderList"
							   style="width: 100%"
							   size="small"
							   border
						   >
							   <el-table-column prop="orderSn" label="权益票订单编号" min-width="150"></el-table-column>
							   <el-table-column prop="ticketName" label="票品名称" show-overflow-tooltip></el-table-column>
							   <el-table-column label="实付金额" min-width="90">
								   <template slot-scope="scope">{{ (scope.row.paidAmount / 10000).toFixed(2) }}元</template>
							   </el-table-column>
							   <el-table-column label="订单状态" min-width="80">
								   <template slot-scope="scope">{{ benefitOrderStatusText(scope.row.orderStatus) }}</template>
							   </el-table-column>
						   </el-table>
					   </div>
					</template>
					<!-- 当前订单为权益票订单（审核通过取消权益票会同步取消主票订单） -->
					<template v-if="cancelData && cancelData.mainTicketInfo">
					   <p class="MT10 color-danger">该订单是权益票订单,审核通过后会同步取消以下主票订单:</p>
					   <div class="temp-table">
						   <el-table
								   :data="[cancelData.mainTicketInfo]"
								   style="width: 100%"
								   size="small"
								   border
							   >
							   <el-table-column prop="orderSn" label="主票订单编号" min-width="150"></el-table-column>
							   <el-table-column prop="ticketName" label="票品名称" show-overflow-tooltip></el-table-column>
							   <el-table-column label="实付金额" min-width="90">
								   <template slot-scope="scope">{{ (scope.row.paidAmount / 10000).toFixed(2) }}元</template>
							   </el-table-column>
							   <el-table-column label="订单状态" min-width="80">
								   <template slot-scope="scope">{{ benefitOrderStatusText(scope.row.orderStatus) }}</template>
							   </el-table-column>
						   </el-table>
					   </div>
					</template>
				 </template>
				<el-form-item label="退票理由" v-if="data.refundType == 1 && (data.applyReason || data.extRemark || data.attachList )" class="MT20">
					<div v-if="data.applyReason">{{data.applyReason}}</div>
					<div v-if="data.extRemark" class="MT10">补充说明：<span class="color-info">{{data.extRemark}}</span></div>
					<el-row v-if="data.attachList" class="attach-list" :gutter="10" type="flex">
						 <el-col v-for="(item,index) in data.attachList" :key="index">
							 <el-image :src="item" fit="cover" :preview-src-list="data.attachList"></el-image>
						 </el-col>
					</el-row>
				 </el-form-item>
                <el-form-item prop="remark" label="审核备注" :rules="[{required: formData.status == 2 ? false : true, message: '请在审核备注填写拒绝通过的理由'}]">
                    <el-input v-model.trim="formData.remark" type="textarea" :rows="2" maxlength="100" show-word-limit ></el-input>
					<small class="MT15"><span class="color-danger">如果【通过】则会直接取消订单 <br>如果【拒绝】则请在审核备注填写原由</span></small>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button v-if="status == 3 || !status" type="danger" @click="submitForm(3)" :loading="btnLoading">拒绝</el-button>
            <el-button v-if="status == 2 || !status" type="primary" @click="submitForm(2)" :loading="btnLoading">通过</el-button>
        </div>
    </el-drawer>
</template>

<script>

const defaultFormData = {
    ids:[],
    remark:'',
    status:'',
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formData: {
                ...defaultFormData,
            },
            status:null,
			data:{},
			cancelData:null,
			chooseTicket:null,
			popShow:false
        }    
    },
	
    methods:{
        //权益票订单状态文案
        benefitOrderStatusText(status){
            const _map = { 1: '待处理', 2: '待发货', 3: '部分发货', 4: '已发货', 5: '已完成', 6: '已过期', 7: '已取消' };
            return _map[status] || '-';
        },
        close(){
            this.formData = { ...defaultFormData };
            this.$refs.formData.resetFields();
            this.drawerShow = false;
			this.cancelData = null
        },
		//status 2是通过 3是拒绝
        show(chooseTicket,status,data){
			this.chooseTicket = chooseTicket
            this.status = status;
			this.data = data
            this.formData = {
                ...defaultFormData,
                status: this.status
            }
            this.drawerShow = true;
			
			if(!status){
			    this.getData();
			}
			
        },
		
		getData(){		    
		    this.$request({
		        url: "/refundTicketAudit/auditCheck",
		        method: "post",
				params:{
					id:this.chooseTicket[0]
				}
		    }).then(res => {
		        const { state, msg, result } = res.data;
		        if (state == 1) {
		            this.cancelData = result
		        } else {
		            this.$message.error(msg || "操作失败,请重试");
		        }
		    })
		},
        submitForm(status){
			this.formData.status = status;
			if( status == 3 && this.formData.remark == '' ){
				return this.$message.error("请在审核备注填写拒绝通过的理由");
			}
			//关联权益票订单确认（审核通过取消主票会同步取消关联的权益票订单）
			if( status == 2 && this.cancelData && this.cancelData.benefitOrderList && this.cancelData.benefitOrderList.length > 0 ){
				const _sns = this.cancelData.benefitOrderList.map(v => v.orderSn).join('、');
				this.$confirm(`该订单有关联的权益票订单:<span class="color-danger">${_sns}</span>,将会同步取消对应权益票订单,确认取消?`, '审核', {
					type: 'warning',
					confirmButtonText: '通过审核',
					cancelButtonText: '返回',
					showClose: false,
					customClass: 'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,
				}).then(() => {
					this.confirmMainTicketCancel(status);
				}).catch(() => {})
				return;
			}
			this.confirmMainTicketCancel(status);
		},
		//当前订单为权益票订单确认（审核通过取消权益票会同步取消主票订单）
		confirmMainTicketCancel(status){
			if( status == 2 && this.cancelData && this.cancelData.mainTicketInfo && this.cancelData.mainTicketInfo.orderSn ){
				const _sn = this.cancelData.mainTicketInfo.orderSn;
				this.$confirm(`该订单是权益票订单,主票订单:<span class="color-danger">${_sn}</span>,审核通过将同步取消主票订单,确认通过审核?`, '审核', {
					type: 'warning',
					confirmButtonText: '通过审核',
					cancelButtonText: '返回',
					showClose: false,
					customClass: 'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,
				}).then(() => {
					this.submitFormRun(status);
				}).catch(() => {})
				return;
			}
			this.submitFormRun(status);
		},
		submitFormRun(status){
			if(  this.chooseTicket  && this.chooseTicket.length > 1){
				this.formData.ids = this.chooseTicket.map( v => v.id )
			}else{
				this.formData.ids = [this.chooseTicket[0]]
			}
			//存在关联权益票订单时，需将权益票的售后单id一并传入（审核时同步处理权益票售后单）
			if( this.cancelData && this.cancelData.benefitOrderList && this.cancelData.benefitOrderList.length > 0 ){
				const _afterSalesIds = this.cancelData.benefitOrderList.map( v => v.afterSalesId ).filter( v => v != null );
				this.formData.ids = [...this.formData.ids, ..._afterSalesIds];
			}
			//当前售后单本身是权益票单时，主票有待审核售后也需一并传入
			if( this.cancelData && this.cancelData.mainTicketInfo && this.cancelData.mainTicketInfo.afterSalesId ){
				this.formData.ids = [...this.formData.ids, this.cancelData.mainTicketInfo.afterSalesId];
			}

			var msg = ''
			if(  this.chooseTicket  && this.chooseTicket.length > 1){
				this.chooseTicket.forEach((tab, idx) => {					
				   if( tab.ticketTypeStr == '实体票' && tab.orderStauts == 4 ){					 
					 this.popShow = true
				   }
				})
				msg = '注意:当前订单包含<span class="color-danger">实体票订单，且已经发货</span>，通过审核取消订单以后可能存在无法收回门票的风险是否确认'
			}else{
				msg = '注意:当前订单是<span class="color-danger">实体票订单，且已经发货</span>，通过审核取消订单以后可能存在无法收回门票的风险是否确认'
			}
			
			if( (  this.popShow == true  && status == 2  ) || ( this.data && this.data.ticketTypeStr == '实体票' && this.data.orderStauts == 4 ) && status == 2 ){
				this.$confirm(msg + `<span class="color-danger">通过审核</span>?`, '审核', {
					type: 'wraning',
					confirmButtonText: '通过审核',
					cancelButtonText:'返回',
					showClose:false,
					customClass:'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,					
				}).then(() => {
					this.subFun()
				}).catch(() => {}) 
				
			}else{
				this.subFun()
			}
        },
		subFun(){
			setTimeout(() => {
			    this.$refs["formData"].validate((valid) => {
			        if (valid) {
			            this.btnLoading = true;
			            this.$request({
			                url: "/refundTicketAudit/audit",
			                data: this.formData,
			                method: "post",
			            })
			                .then((res) => {
			                    const { state, msg, result } = res.data;
			                    if (state == 1) {
			                        this.$emit('onUpdate');
			                        this.close();
			                    } else {
			                        this.$message.error(msg || "操作失败,请重试");
			                    }
			                })
			                .catch(() => {
			                    this.$message.error("操作失败,请重试");
			                })
			                .finally(() => {
			                    this.btnLoading = false;
			                });
			        } else {
			            return false;
			        }
			    });
			})
		}
    }
}
</script>
<style lang="scss" scoped>
.attach-list{
    .el-col{
        margin-top: 10px;
        width: 80px;
        height: 80px;
        .el-image{
            width: 100%;
            height: 100%;
        }
    }
}
::v-deep .color-blue{	
	color:#409EFF;
	font-size: 12px
}
.temp-table{
	margin-top: 10px;
	max-height: 300px;
	min-height: 100px;
	overflow-y:auto;
	::v-deep .el-table,.el-table thead{
		color:#f00
	}	
	
}
</style>